
  class RestrictedCartItemCleaner {
    #blockedVariantIds = new Set([51651841294682,47781422399834]);
    #isRunning = false;

    async #getCart() {
      const response = await fetch('/cart.js', {
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        throw new Error('Cart fetch failed');
      }

      return response.json();
    }

    async #removeBlockedItems(updates) {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error('Cart update failed');
      }

      document.dispatchEvent(new CustomEvent('cartUpdated'));

      return data;
    }

    async sync(trigger = 'manual') {
      if (this.#isRunning) return;
      this.#isRunning = true;

      try {
        const cart = await this.#getCart();
        const updates = {};

        cart.items.forEach((item) => {
          if (this.#blockedVariantIds.has(Number(item.id))) {
            updates[item.id] = 0;
          }
        });

        if (Object.keys(updates).length) {
          await this.#removeBlockedItems(updates);
        }
      } catch (error) {
        console.error('[RestrictedCartItemCleaner]', trigger, error);
      } finally {
        this.#isRunning = false;
      }
    }

    init() {
      const bind = () => {
        this.sync('DOMContentLoaded');
        document.addEventListener('cartAdded', () => this.sync('cartAdded'));
        document.addEventListener('cartUpdated', () => this.sync('cartUpdated'));
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bind, { once: true });
      } else {
        bind();
      }
    }
  }

  new RestrictedCartItemCleaner().init();
